import { useEffect, useState } from 'react';

import { screens as breakpoints } from '@/../tailwind/theme';

const getNumber = (value: string): number => {
  const foundNumber = value.match(/([0-9.]*)/);

  if (foundNumber === null) {
    throw new Error(`No number found in '${value}' string.`);
  }

  return parseFloat(foundNumber[0]);
};

const useBreakpoint = () => {
  const [screenWidth, setScreenWidth] = useState<number>(
    typeof window !== 'undefined' ? window.innerWidth : 0,
  );
  const [screenHeight, setScreenHeight] = useState<number>(
    typeof window !== 'undefined' ? window.innerHeight : 0,
  );

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    let timeoutId: ReturnType<typeof setTimeout>;

    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setScreenWidth(window.innerWidth);
        setScreenHeight(window.innerHeight);
      }, 100);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isMobile = screenWidth < getNumber(breakpoints.md);

  const isPortrait = screenHeight > screenWidth;

  const currentBreakpoint =
    Object.entries(breakpoints)
      .reverse()
      .find(([_, value]) => screenWidth >= getNumber(value))?.[0] ?? 'sm';

  return {
    screenWidth,
    currentBreakpoint,
    breakpoints,
    isMobile,
    isPortrait,
  };
};

export default useBreakpoint;
